import I18n from '@app/adapters/I18n'
import type { TemplateReview } from '@app/application/workflows/types'
import type { ReviewState } from '@app/insights/types'

/**
 * Compute review state from reviews array
 * Shared logic used by both review-cell.vue and formatReviews
 */
const getReviewState = (
  reviews: TemplateReview[] | null | undefined
): ReviewState => {
  const hasReviews = !!reviews && reviews.length > 0
  const hasAnyUpToDateReview =
    hasReviews && reviews.some((review) => review.outdatedAt === null)

  const prefix = hasAnyUpToDateReview
    ? I18n.t('reconciliation_review.reviewed_by')
    : I18n.t('reconciliation_review.previously_reviewed_by')

  return { hasReviews, hasAnyUpToDateReview, prefix }
}

export default getReviewState
